import * as React from 'react';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import {
	followUser,
	getUserSearchResults,
	resetSearchData,
	unfollowUser,
} from 'redux/modules/search/usersearchresults';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { ItemCardList, NoResults } from 'components';
import { ErrorPage } from 'containers';
import { ResultsWrapper } from 'components/PortalStructure';
import { getNextPageCount } from 'helpers/common';
import { Dispatch } from 'redux';

interface IProps extends Partial<ReturnType<typeof stateToProps>>, Partial<ReturnType<typeof dispatchToProps>> {
	relativeUrl?: string;
	t?: (key: string) => string;
}

const stateToProps = (state: IStore) => ({
	search: state.userSearchResults,
	userPreferences: state.userPreferences,
	followingItems: state.userSearchResults?.items || [],
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	getUserSearchResults: (isFirstLoad: boolean, keyword: string) => dispatch(getUserSearchResults(isFirstLoad, keyword)),
	followItem: (id: string) => dispatch(followUser(id)),
	unfollowItem: (id: string) => dispatch(unfollowUser(id)),
	resetSearchData: () => dispatch(resetSearchData()),
});

@connect(stateToProps, dispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserSearchResults extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
	}

	public loadMoreData() {
		this.props.getUserSearchResults(false, this.props.search.keyword);
	}

	public componentWillUnmount() {
		this.props.resetSearchData();
	}

	public render() {
		if (this.props.search.error) {
			return <ErrorPage {...this.props} message={this.props.search.message} />;
		}

		const { items, itemsPage, isFetching, keyword } = this.props.search;
		const { t, userPreferences } = this.props;

		if (!itemsPage) {
			return null;
		}

		const nextPageItems = getNextPageCount(itemsPage, items.length);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: nextPageItems > 0,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_USER_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			followItem: (_: string, id: string) => this.props.followItem(id),
			unfollowItem: (_: string, id: string) => this.props.unfollowItem(id),
			followingItems: this.props.followingItems,
			currentUserId: userPreferences.id,
			isFetching,
			loadingText: t('BSPortal_Common_Loading'),
			noResults: <NoResults keyword={keyword} t={t} />,
			nextPageItems,
		};

		return (
			<ResultsWrapper>
				<ItemCardList {...listProps} />
			</ResultsWrapper>
		);
	}
}
export { UserSearchResults };
